package game.entity

import game.Game
import game.Room

class EndFather: Entity() {
    override fun onInit(game: Game, room: Room) {
        val alive = game.collectedAllLore
        if (alive) {
            sprite = game.getSpriteById("npc-dark-red")
        } else {
            sprite = null
            room.removeEntity(this)
        }
    }

    override fun onCollideWithPlayer(game: Game, room: Room): Boolean {
        game.showDialog("Npc_FatherSaved")

        return false
    }
}

class EndPortal: Entity() {
    override fun onInit(game: Game, room: Room) {
        sprite = game.getSpriteById("large-shard")
    }

    override fun onCollideWithPlayer(game: Game, room: Room): Boolean {
        game.playSound("shard-pickup-3")

        if (game.collectedAllLore) {
            game.startTeleportTransition(game.player.col, game.player.row, 22, 5, "auditorium-a", true)
        } else {
            game.startTeleportTransition(game.player.col, game.player.row, 22, 5, "auditorium-b", true)
        }

        return true
    }
}